// import React from 'react'
// import { useNavigate } from 'react-router-dom';

// const Logo = () => {
//     const Navigate = useNavigate();
//     return (
//         <header className="flex flex-col items-start w-full cursor-pointer" onClick={() => Navigate('/')}>
//             <div
//                 className="bg-[#1d1d1d] rounded-xl px-6 py-4 inline-flex items-end justify-center shadow-sm"
//                 role="img"
//                 aria-label="InstaED logo"
//             >
//                 <span className="text-white text-2rem sm:text-3xl italic font-srisakdi">Insta</span>
//                 <span className="text-white text-5xl sm:text-6xl font-black leading-none">ED</span>
//             </div>
//             <p className="mt-3 text-[#2c2c2c] text-base sm:text-lg tracking-wide font-medium">
//                 Online Tuitions | 6–12
//             </p>
//         </header>
//     )
// }

// export default Logo



import React from "react";
import { useNavigate } from "react-router-dom";

const Logo = () => {
    const navigate = useNavigate();

    return (
        <header
            className="flex flex-col items-start w-max cursor-pointer select-none"
            onClick={() => navigate("/")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    navigate("/");
                }
            }}
            aria-label="InstaED Tuitions home"
        >
            {/* Logo Name */}
            <div className="font-['Poppins'] text-[24px] sm:text-[24px] leading-[1.08] font-extrabold tracking-[-0.85px] whitespace-nowrap text-[#17144b]">
                Insta
                <span className="text-[#c95a38] italic font-semibold">
                    ED
                </span>
                {" "}Tuitions
            </div>

            {/* Tagline */}
            <div className="mt-[5px] text-[10px] leading-[1.2] font-medium tracking-[0.16em] whitespace-nowrap uppercase text-[#8c84a0]">
                ONLINE TUITIONS · CLASSES 6–10
            </div>
        </header>
    );
};

export default Logo;
